import { OnInit, EventEmitter, ElementRef } from '@angular/core';
import { MatCheckboxChange } from '@angular/material';
import { OccurencesService } from '../../occurences.service';
import { OccurenceType } from '../../model/occurence-type.model';
import { NgForm, FormGroup } from '@angular/forms';
import { UtilService } from '@app/shared/utils';
import { CONSTANTS } from '@app/shared/constants';
var OccurenceTypesComponent = /** @class */ (function () {
    function OccurenceTypesComponent(occurrencesService, utils, elRef) {
        this.occurrencesService = occurrencesService;
        this.utils = utils;
        this.elRef = elRef;
        this.newSelect = new EventEmitter();
        this.occurenceTypesChangeEvt = new EventEmitter();
        this.manageDataFields = new EventEmitter();
        this.typesSelectedList = new Array();
    }
    OccurenceTypesComponent.prototype.ngOnInit = function () {
        this.getOccurenceTypes();
        this.occurenceTypesChangeEvt.emit(this.occurrenceTypes);
    };
    OccurenceTypesComponent.prototype.getOccurenceTypes = function () {
        var _this = this;
        this.occurenceTypesSubscription = this.occurrencesService.getOccurenceTypes().subscribe(function (list) {
            list.forEach(function (item) {
                item.disabled = false;
                if (_this.utils.containsTypeOpenImpl(item.name)) {
                    item.messageDisable = CONSTANTS.INFO_DISABLE_OCC_TYPE_OPEN_IMPL;
                }
                else {
                    item.messageDisable = CONSTANTS.INFO_DISABLE_NEW_EVENTS;
                }
            });
            _this.occurrenceTypes = list;
            if (_this.isVisualization) {
                _this.occurrenceTypes.forEach(function (occurrencType) {
                    occurrencType.disabled = true;
                });
            }
            _this.threatOccurrenceTypesChecked();
        });
    };
    OccurenceTypesComponent.prototype.onChange = function (e) {
        this.handleValidateDisabledInputs(e);
        var occurenceType = new OccurenceType(+e.source.id, e.source.name);
        if (e.checked) {
            this.typesSelectedList.push(occurenceType);
        }
        else {
            var removeIndex = this.typesSelectedList.map(function (item) { return item.id; }).indexOf(occurenceType.id);
            this.typesSelectedList.splice(removeIndex, 1);
        }
        this.typesForm.controls.typesListControl.setValue(this.typesSelectedList);
        this.newSelect.emit(this.typesSelectedList);
    };
    OccurenceTypesComponent.prototype.handleValidateDisabledInputs = function (e) {
        var _this = this;
        var type = e.source;
        if (!e.checked && this.typesSelectedList.length === 1) {
            this.occurrenceTypes.forEach(function (occurrencType) {
                occurrencType.disabled = false;
            });
        }
        else if (this.utils.containsTypeOpenImpl(type.name)) {
            this.manageDataFields.emit(true);
            this.occurrenceTypes.forEach(function (occurrencType) {
                if (!_this.utils.containsTypeOpenImpl(occurrencType.name)) {
                    occurrencType.disabled = true;
                }
            });
        }
        else {
            this.occurrenceTypes.forEach(function (occurrencType) {
                if (_this.utils.containsTypeOpenImpl(occurrencType.name)) {
                    occurrencType.disabled = true;
                }
            });
        }
    };
    OccurenceTypesComponent.prototype.havePortfolioSelected = function (event) {
        var _this = this;
        this.occurrenceTypes.forEach(function (occurrencType) {
            if (_this.utils.containsTypeOpenImpl(occurrencType.name)) {
                if (event) {
                    occurrencType.disabled = true;
                    occurrencType.checked = false;
                }
                else {
                    occurrencType.disabled = false;
                }
            }
        });
    };
    OccurenceTypesComponent.prototype.containsTypeOpenImpl = function (name) {
        return this.utils.containsTypeOpenImpl(name);
    };
    OccurenceTypesComponent.prototype.threatOccurrenceTypesChecked = function () {
        var _this = this;
        if (Array.isArray(this.occurrenceTypes) && this.occurrenceTypes.length > 0
            && Array.isArray(this.typesChecked) && this.typesChecked.length > 0) {
            this.occurrenceTypes.forEach(function (item) {
                _this.typesChecked.forEach(function (typeChecked) {
                    if (typeChecked.occurrenceType.id === item.id) {
                        item.checked = true;
                        _this.typesSelectedList.push(typeChecked.occurrenceType);
                    }
                });
            });
            this.newSelect.emit(this.typesSelectedList);
        }
    };
    OccurenceTypesComponent.prototype.disableAllCheckboxes = function () {
        this.occurrenceTypes.forEach(function (occurrencType) {
            occurrencType.disabled = true;
        });
    };
    return OccurenceTypesComponent;
}());
export { OccurenceTypesComponent };
